/*
 * Retorna os webservices gratuitos de consulta de CNPJ, na ordem em que são consultados:
 * o seguinte só é usado se o anterior falhar (fora do ar, limite de consulta, bloqueio)
 * Cada webservice tem a url da consulta e a função que extrai os dados do retorno dele
 * OBS: Todos respondem 404 quando o CNPJ não existe
 * @param cnpj: Número do cnpj sem formatação
 */
export function fn_loadWebservicesCnpj(cnpj) {
  return [
    {
      nome: "brasilapi",
      url: `https://brasilapi.com.br/api/cnpj/v1/${cnpj}`,
      fn_extrairDados: (data) => ({
        razao_social: data?.razao_social || "",
        nome_fantasia: data?.nome_fantasia || "",
        cep: data?.cep,
        numero: data?.numero || "",
        complemento: data?.complemento || "",
      }),
    },
    {
      nome: "opencnpj",
      url: `https://api.opencnpj.org/${cnpj}`,
      fn_extrairDados: (data) => ({
        razao_social: data?.razao_social || "",
        nome_fantasia: data?.nome_fantasia || "",
        cep: data?.cep,
        numero: data?.numero || "",
        complemento: data?.complemento || "",
      }),
    },
    {
      //Limite de 3 consultas por minuto por IP
      nome: "cnpj.ws",
      url: `https://publica.cnpj.ws/cnpj/${cnpj}`,
      fn_extrairDados: (data) => ({
        razao_social: data?.razao_social || "",
        nome_fantasia: data?.estabelecimento?.nome_fantasia || "",
        cep: data?.estabelecimento?.cep,
        numero: data?.estabelecimento?.numero || "",
        complemento: data?.estabelecimento?.complemento || "",
      }),
    },
  ];
}
